import { isString } from 'util';
export default window.filters = {

    formatPercent (value, columnType) {
        if (isString(value)) {
            return value;
        } else if (isNaN(value) || value === null) {
            return 'N/A';
        }

        if (columnType === 'percent') {
            if ($.isNumeric(value)) {
                value = ((value * 1000) / 10).toFixed(0); //JS gives .575 * 100 = 57.49. To fix this we are multiplying by 1000 and the divide by 10

                if (value == 0) {
                    return value;
                }
                else if (value < 1) {
                    return '< 1%';
                } else {
                    return value + '%';
                }
            } else {
                return value;
            }

        } else if (columnType === 'number') {
            if (value) {
                return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            }
        }

        return value;

    },
    categoryNameFilter (value) {
        if (value) {
            switch (value) {
                case 'Injury (total) Accidents/Adverse Effects':
                    return 'Injury (Total) Accidents/Adverse Effects';
                case 'Injury - Traumatic brain injury':
                case 'Screening And Brief Intervention For Substance Abuse':
                    return value.toTitleCase();
                default:
                    return value;
            }
        }
    },
    dict (value) {
        switch (value) {
            case 'Gender':
                return 'Sex/Gender';
            case '':
                return 'All NIH';
            default:
                return value;
        }
    }
}
